<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Отчет по выполненным биотехническим, охранным и охотхозяйственным мероприятиям') }}</h1>
    <div class="my-organization">
      <div class="bso-reports hunters-pg create bgw-pdg-20">
        <h4 class="text-center mt-1">
          {{ $t('Отчет по выполненным биотехническим, охранным и охотхозяйственным мероприятиям') }}</h4>
        <v-form ref="form" @submit.prevent="save" lazy-validation>
          <div class="form-head">
            <v-row>
              <v-col cols="12" md="3" :class="{ invalid: $v.event.year.$error }">
                <label>{{ $t('Год') }}: <span class="asterix">*</span></label>
                <div class="select-def">
                  <v-select
                    :items="refYears"
                    item-value="id"
                    item-text="transName"
                    v-model="event.year"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
              </v-col>
              <v-col cols="12" md="3" :class="{ invalid: $v.event.quarter.$error }">
                <label>{{ $t('Квартал') }}: <span class="asterix">*</span></label>
                <div class="select-def">
                  <v-select
                    :items="refQuarters"
                    item-value="id"
                    item-text="transName"
                    v-model="event.quarter"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" :class="{ invalid: $v.event.oopt.$error }">
                <label>{{ $t('Организация') }}: <span class="asterix">*</span></label>
                <div class="select-def">
                  <v-select
                    :items="oopts"
                    item-value="id"
                    item-text="transName"
                    v-model="event.oopt"
                    outlined
                    dense
                    required
                    clearable
                    @change="ooptObserverList"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="form-body">
            <div class="tab-main">
              <DataTable
                :eventsData="eventsData"
                :edit="true"
              >
              </DataTable>
            </div>
            <div class="form-group">
              <div class="quota-fields">
                <div class="quota-field field-block" :class="{ invalid: $v.event.ooptObserver.$error }">
                  <label>{{ $t('Составитель') }}: <span class="asterix">*</span></label>
                  <div class="quota-fields">
                    <div class="quota-field mr-2">
                      <div class="select-def size-md-2">
                        <v-select
                          :items="ooptObservers"
                          item-value="id"
                          item-text="transFio"
                          v-model="event.ooptObserver"
                          outlined
                          dense
                          required
                          clearable
                        />
                      </div>
                      <ObserverAdd
                        :ooptId="event.oopt"
                        :observerFromAccountCard="true"
                        :label="$t('Составители')"
                        @ooptObserverList="ooptObserverList($event)"
                        class="pt-0 pb-0"
                      >
                      </ObserverAdd>
                    </div>
                  </div>
                </div>
                <div class="quota-field field-block" :class="{ invalid: $v.event.date.$error }">
                  <label>{{ $t('Дата') }}: <span class="asterix">*</span></label>
                  <div class="datepicker-main">
                    <div class="form-date">
                      <v-icon class="date-icon">date_range</v-icon>
                      <VueCtkDateTimePicker
                        v-model="event.date"
                        format="DD.MM.YYYY"
                        formatted="LL"
                        :onlyDate="true"
                        :label="''"
                        :autoClose="true"
                        :noButton="true"
                        class="size-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('Примечание') }}:</label>
              <v-textarea
                v-model="event.note"
                outlined
                dense
              />
            </div>
            <div class="form-group">
              <div class="quota-fields justify-content-between align-center">
                <div class="quota-field">
                  <div class="checkbox-list">
                    <v-checkbox
                      :label="$t('Отчет готов к отправке')"
                      v-model="valid"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--Кнопки действии-->
            <div class="form-action text-center">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Events from '@/model/events'
import ObserverAdd from '@/components/oopt/ObserverAdd'
import { required, requiredIf } from 'vuelidate/lib/validators'
import DataTable from '@/components/event/DataTable'

export default {
  components: {
    ObserverAdd,
    DataTable
  },
  data: () => ({
    breadcrumbs: [],
    event: {},
    tabReport: null,
    refYears: [],
    refQuarters: [],
    oopts: [],
    ooptObservers: [],
    eventsData: [],
    valid: false,
    statusArray: [],
    rules: {
      event: {
        quarter: { required },
        year: { required },
        oopt: {
          required: requiredIf(
            function () {
              return this.oopts.length > 1
            })
        },
        ooptObserver: { required },
        date: { required }
      }
    }
  }),
  validations () {
    return this.rules
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Events.getEventReportData(this.$route.params.id).then((response) => {
        this.event = response.data.eventReport
        this.eventsData = response.data.data
        this.generateBreadcrumbs()
        this.ooptObserverList(this.event.oopt)
        Events.getEventReportFormData().then((response) => {
          this.refYears = response.data.refYears
          this.refQuarters = response.data.refQuarters
          this.oopts = response.data.oopts
          this.statusArray = response.data.statusArray
          this.valid = this.event.status === this.statusArray[1]
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    ooptObserverList (id) {
      Events.getOoptObservers(id).then((response) => {
        this.ooptObservers = response.data.ooptObservers
      })
        .catch((error) => {
          console.log(error)
        })
    },
    save () {
      if (!this.validateForm()) {
        return
      }
      this.setLoading(true)
      const statusId = this.valid ? this.statusArray[1] : this.statusArray[0]
      const fd = {
        year: this.event.year,
        quarter: this.event.quarter,
        oopt: this.event.oopt,
        ooptObserver: this.event.ooptObserver,
        date: this.event.date,
        note: this.event.note,
        eventData: []
      }
      const fdEventData = []
      Object.entries(this.eventsData).forEach(([eventDataKey, eventData]) => {
        Object.entries(eventData.events).forEach(([eventKey, event]) => {
          if (event.eventData.planCount !== undefined || event.eventData.planSum !== undefined || event.eventData.factCount !== undefined || event.eventData.factSum !== undefined) {
            fdEventData.push({
              id: event.eventData.id !== undefined ? event.eventData.id : 0,
              eventType: eventData.id,
              event: eventKey,
              planCount: (event.eventData.planCount !== undefined && event.eventData.planCount !== '') ? event.eventData.planCount : null,
              planSum: (event.eventData.planSum !== undefined && event.eventData.planSum !== '') ? event.eventData.planSum : null,
              factCount: (event.eventData.factCount !== undefined && event.eventData.factCount !== '') ? event.eventData.factCount : null,
              factSum: (event.eventData.factSum !== undefined && event.eventData.factSum !== '') ? event.eventData.factSum : null
            })
          }
        })
        Object.entries(eventData.children).forEach(([childKey, childEvent]) => {
          Object.entries(childEvent.events).forEach(([childEventKey, childEventData]) => {
            if (childEventData.eventData.planCount !== undefined || childEventData.eventData.planSum !== undefined || childEventData.eventData.factCount !== undefined || childEventData.eventData.factSum !== undefined) {
              fdEventData.push({
                id: childEventData.eventData.id !== undefined ? childEventData.eventData.id : 0,
                eventType: childEvent.id,
                event: childEventKey,
                planCount: (childEventData.eventData.planCount !== undefined && childEventData.eventData.planCount !== '') ? childEventData.eventData.planCount : null,
                planSum: (childEventData.eventData.planSum !== undefined && childEventData.eventData.planSum !== '') ? childEventData.eventData.planSum : null,
                factCount: (childEventData.eventData.factCount !== undefined && childEventData.eventData.factCount !== '') ? childEventData.eventData.factCount : null,
                factSum: (childEventData.eventData.factSum !== undefined && childEventData.eventData.factSum !== '') ? childEventData.eventData.factSum : null
              })
            }
          })
        })
      })
      fd.eventData = fdEventData
      Events.editEventReport(this.$route.params.id, statusId, fd).then((response) => {
        if (response.status === 202) {
          this.onCancel()
        }
        this.setLoading(false)
      }).catch((error) => {
        console.log(error)
        this.setLoading(false)
      })
    },
    // отмена
    onCancel () {
      this.$router.push({
        name: 'event-show',
        params: { id: this.$route.params.id }
      })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Отчеты по мероприятиям'),
          disabled: false,
          href: '/event-list'
        },
        {
          text: this.$i18n.t('Отчет по выполненным биотехническим, охранным и охотхозяйственным мероприятиям'),
          disabled: true
        }
      ]
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-link {
  img {
    margin-right: 5px;
    vertical-align: middle;
  }
}
</style>
